try {
    window.$ = window.jQuery = require('jquery');
    $.fn.isAboveViewport = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();
        var viewportTop = $(window).scrollTop();
        return elementBottom > viewportTop;
    };

    // Set the CSRF Token for all AJAX requests
    let csrfName = document.head.querySelector('meta[name="csrf-name"]');
    let csrfToken = document.head.querySelector('meta[name="csrf-token"]');

    if (csrfName && csrfToken) {
        $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
            jqXHR.setRequestHeader(csrfName.content, csrfToken.content);
        });
    } else {
        console.error('CSRF config not found in head');
    }


    require('bootstrap');
} catch (e) {
}

